import { Icon, Text } from '@dixa/lib-shared-habla';
import { typography } from '@dixa/lib-shared-tokens';
import classNames from 'classnames';
import { memo, useCallback, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';

import { type InstrumentPanelDescriptionProps } from '../../instrumentPanelDescription';

import styles from './instrumentPanelDescriptionEditor.module.scss';

type InstrumentPanelDescriptionEditorFormValues = {
  description?: string;
};

export const InstrumentPanelDescriptionEditor = memo(
  function AnalyticsPanelDescriptionEditor({
    panel,
    onChange: onEdit,
  }: InstrumentPanelDescriptionProps): JSX.Element | null {
    const [isEditMode, setIsEditMode] = useState(false);

    const form = useForm<InstrumentPanelDescriptionEditorFormValues>({
      mode: 'onBlur',
      defaultValues: {
        description: panel.description,
      },
    });

    const handleBlur = useCallback(() => {
      setIsEditMode(false);
      if (onEdit) form.handleSubmit(onEdit)();
    }, [form, onEdit]);

    const placeholder =
      'What is this panel about? Enter an optional description here...';

    if (isEditMode) {
      return (
        <Controller
          name="description"
          control={form.control}
          defaultValue=""
          render={({ field }) => (
            <textarea
              {...field}
              className={styles.textarea}
              placeholder={placeholder}
              onBlur={handleBlur}
              autoFocus
            />
          )}
        />
      );
    }

    return (
      <div
        role="button"
        aria-label="Edit description"
        className={classNames({
          [styles.root]: true,
          [styles.rootEmpty]: !panel.description,
        })}
        onClick={() => setIsEditMode(true)}
      >
        <Text.Paragraph as="div" variant="4" subdued className={styles.text}>
          {panel.description ?? placeholder}
        </Text.Paragraph>

        <Icon
          className={styles.icon}
          name="pen"
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          size={12}
          color={typography.color.secondary}
        />
      </div>
    );
  },
);
